import styles from './SlowCircularProgress.module.css';
import { CircularProgress } from '@mui/material';
import React from 'react';

export const SlowCircularProgress: React.FC = () => <CircularProgress className={styles.slow} disableShrink />;
